import {
  useMutationClubDetails,
  useQueryClubDetails,
  useQueryCustomPaymentCategory,
} from "@gymflow/api";
import { CustomPaymentCategoryDTO } from "@gymflow/types";
import { createColumnHelper } from "@tanstack/react-table";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { ApiResolverContext } from "../../../providers/ApiResolverProvider/ApiResolverContext";
import useGymflowModels from "../../../store";
import { LabeledSwitch } from "../../atoms";
import { PaginatedTable } from "../../organisms";

export const PaymentMethodsTabInPerson = () => {
  const { t } = useTranslation();
  const { clubId } = useContext(ApiResolverContext);

  const { api } = useGymflowModels();
  const columnHelper = createColumnHelper<CustomPaymentCategoryDTO>();

  const {
    data: dataCustomPaymentCategory,
    isLoading: isLoadingCustomPaymentCategory,
  } = useQueryCustomPaymentCategory({ api, clubId });
  const { data: club, isLoading: isClubLoading } = useQueryClubDetails({
    api,
    clubId,
  });

  const {
    mutateAsync: mutateAsyncClubDetails,
    isPending: isLoadingClubDetails,
  } = useMutationClubDetails({
    api,
  });

  const columns = [
    columnHelper.accessor("name", {
      header: () => t("page.settings.tab.paymentMethods.table.header.name"),
      cell: (column) => (
        <div className="text-sm font-medium text-gray-900">
          {column.getValue()}
        </div>
      ),
    }),
  ];
  return (
    <PaginatedTable
      tableProps={{
        data: dataCustomPaymentCategory ?? [],
        columns: columns,
        isFetching: isLoadingCustomPaymentCategory,
      }}
      aboveTable={
        <div className="relative p-6 pl-5">
          <LabeledSwitch
            label={t("page.settings.tab.paymentMethods.inPersonPaymentsSwitch")}
            value={club?.customPaymentsEnabled ?? false}
            disabled={isLoadingClubDetails || isClubLoading}
            onChange={async (checked) => {
              await mutateAsyncClubDetails({
                clubId,
                payload: { customPaymentsEnabled: checked },
              });
            }}
          />
        </div>
      }
      // Right now we don't have pagination for the table
      hasNextPage={false}
      hasPreviousPage={false}
      goToNextPage={() => {}}
      goToPreviousPage={() => {}}
    />
  );
};
